export default __webpack_public_path__ + "static/media/logo-psychflex-negative.26f7c6cf.png";